module.exports = __webpack_public_path__ + "static/media/Conflicts_of_Interest_Policy_FSA.981c864a.pdf";